import React, { useState, useEffect, useRef, useContext } from "react";
import PropTypes from "prop-types";
import { CredsContext, CredsSetterContext } from "./Contexts";
import Tools from "./JNSTools";
import RAIDComponent from "./RAIDComponent";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";

function RAIDContainer(props) {
  const creds = useContext(CredsContext).creds;
  //const ISSUE_CATEGORY_ID = 5; // 5 in sandbox, 10 in prod
  const [issueArray, setIssueArray] = useState([]);
  const origIssueArray = useRef([]);
  const authString = Tools.getXmlBodyAuthString(creds);
  const urlString = Tools.getInstanceUrl(creds);
  const projectTeam = useRef([]); // array of last, first - strings, not objects
  //const approvalMembers = useRef([]);
  //const acknowledgementMembers = useRef([]);
  const loadCompleted = useRef(false);
  const [dirty, isDirty] = useState(false);
  const [openConfigAlert, setOpenConfigAlert] = useState(false);
  let ISSUE_CATEGORY_ID;
  let ISSUE_CATEGORY_ARRAY;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));

  const userFullName = creds.name;
  const userFirstName = userFullName
    .substring(userFullName.indexOf(",") + 1)
    .trim();
  const userLastName = userFullName.substring(0, userFullName.indexOf(","));

  const oadaSettingsRaw = localStorage.getItem("oadaSettings");
  if (oadaSettingsRaw) {
    const oadaSettings = JSON.parse(oadaSettingsRaw);
    if (props.raidType == "all") {
      ISSUE_CATEGORY_ID = -1;
      const raidTypesArray = [
        "risk",
        "action",
        "assumption",
        "issue",
        "decision",
      ];
      ISSUE_CATEGORY_ARRAY = raidTypesArray.map(
        (elem) => oadaSettings[elem + "CategoryDropdown_options"],
      );
    } else {
      ISSUE_CATEGORY_ID =
        oadaSettings[props.raidType + "CategoryDropdown_options"];
    }
  }

  useEffect(() => {
    if (!ISSUE_CATEGORY_ID) {
      setOpenConfigAlert(true);
    }
  }, [ISSUE_CATEGORY_ID]);

  const handleNotificationClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setOpenConfigAlert(false);
  };

  useEffect(() => {
    props.waitHandler(true);

    /*const globalDataObject = new GlobalData(creds);
    globalDataObject.populateTable("IssueCategory").then(() => {
      const issueCategories = JSON.parse(
        localStorage.getItem(creds.company + "|IssueCategory"),
      );
      const issueCatElement = issueCategories.find(
        (elem) => elem.name == "Issue",
      );
      if (issueCatElement) {
        //ISSUE_CATEGORY_ID = issueCatElement.id;
      } else {
        alert(
          "ERROR: Misisng Issue Category.  If this has been resolved in SuiteProjects Pro, revisiting this page will reflect the change.  Otherwise, please contact your SuiteProjects Pro Administrator.",
        );
        localStorage.removeItem(creds.company + "|IssueCategory");
      }
*/
    if (projectObject.oada_project_team__c) {
      projectTeam.current = [];
      const memberArray = projectObject.oada_project_team__c.split(";");
      memberArray.forEach((memberRecord, index) =>
        projectTeam.current.push({
          name: memberRecord.substring(0, memberRecord.indexOf("|")),
          id: memberRecord.substring(
            memberRecord.indexOf("|") + 1,
            memberRecord.indexOf("|", memberRecord.indexOf("|") + 1),
          ),
        }),
      );
      projectTeam.current.pop();
    }

    let requestString = authString;
    if (ISSUE_CATEGORY_ID == -1) {
      requestString +=
        '<Read type="Issue" method="equal to" limit="1000" enable_custom="1"><Issue><project_id>' +
        projectObject.id +
        "</project_id></Issue></Read></request>";
    } else {
      requestString +=
        '<Read type="Issue" method="equal to" limit="1000" enable_custom="1"><Issue><issue_category_id>' +
        ISSUE_CATEGORY_ID +
        "</issue_category_id><project_id>" +
        projectObject.id +
        "</project_id></Issue></Read></request>";
    }
    let issueRecords = [];
    //if (ISSUE_CATEGORY_ID == -1) {
    origIssueArray.current = [];
    //}
    Tools.fetchPost(requestString, urlString, "Issue").then(
      (issueRecordXML) => {
        if (issueRecordXML.xml.length > 0) {
          issueRecords = Tools.xmlToArray(issueRecordXML.xml);

          if (ISSUE_CATEGORY_ID == -1) {
            issueRecords.forEach((elem) => {
              if (ISSUE_CATEGORY_ARRAY.indexOf(elem.issue_category_id) >= 0) {
                origIssueArray.current.push(elem);
              }
            });
          } else {
            origIssueArray.current = issueRecords;
          }
        }
        // "loadCompleted.current" eists only to assist with waitHandler timing, no other purpose
        loadCompleted.current = true;
        props.waitHandler(false);
        setIssueArray(origIssueArray.current);
      },
    );
  }, [dirty, props.raidType]);

  // "loadCompleted.current" exists only to assist with waitHandler timing, no other purpose
  function resetLoadCompleted() {
    loadCompleted.current = false;
  }

  const updateIssue = (issue, editorDetails) => {
    if (typeof issue.dateReq == "string") {
      issue.dateReq = new Date(issue.dateReq);
    } else if (issue.dateReq == "Invalid Date") {
      issue.dateReq = null;
    }

    if (typeof issue.dateExp == "string") {
      issue.dateExp = new Date(issue.dateExp);
    } else if (issue.dateExp == "Invalid Date") {
      issue.dateExp = null;
    }

    if (typeof issue.dateRes == "string") {
      issue.dateRes = new Date(issue.dateRes);
    } else if (issue.dateRes == "Invalid Date") {
      issue.dateRes = null;
    }

    const foundOrigIndex = origIssueArray.current.findIndex(
      (elem) => elem.id == issue.id,
    );

    const changeArray = [];
    if (origIssueArray.current[foundOrigIndex].description != issue.synopsis) {
      changeArray.push({
        field: "Description",
        oldVal: origIssueArray.current[foundOrigIndex].description,
        newVal: issue.synopsis,
      });
      origIssueArray.current[foundOrigIndex].description = issue.synopsis;
    }

    if (origIssueArray.current[foundOrigIndex].user_id != issue.userId) {
      changeArray.push({
        field: "Assignee",
        oldVal: Tools.valueFromId(
          origIssueArray.current[foundOrigIndex].user_id,
          "User",
          creds,
        ),
        newVal: Tools.valueFromId(issue.userId, "User", creds),
      });
      origIssueArray.current[foundOrigIndex].user_id = issue.userId;
    }

    if (
      origIssueArray.current[foundOrigIndex].issue_stage_id != issue.stageId
    ) {
      changeArray.push({
        field: "Stage",
        oldVal: Tools.valueFromId(
          origIssueArray.current[foundOrigIndex].issue_stage_id,
          "IssueStage",
          creds,
        ),
        newVal: Tools.valueFromId(issue.stageId, "IssueStage", creds),
      });
      origIssueArray.current[foundOrigIndex].issue_stage_id = issue.stageId;
    }

    let removeRecordFromArray = false;
    if (
      origIssueArray.current[foundOrigIndex].issue_category_id !=
      issue.categoryId
    ) {
      changeArray.push({
        field: "Category",
        oldVal: Tools.valueFromId(
          origIssueArray.current[foundOrigIndex].issue_category_id,
          "IssueCategory",
          creds,
        ),
        newVal: Tools.valueFromId(issue.categoryId, "IssueCategory", creds),
      });
      origIssueArray.current[foundOrigIndex].issue_category_id =
        issue.categoryId;
      if (props.raidType != "all") {
        removeRecordFromArray = true;
      }
    }

    if (
      origIssueArray.current[foundOrigIndex].issue_severity_id !=
      issue.severityId
    ) {
      changeArray.push({
        field: "Priority",
        oldVal: Tools.valueFromId(
          origIssueArray.current[foundOrigIndex].issue_severity_id,
          "IssueSeverity",
          creds,
        ),
        newVal: Tools.valueFromId(issue.severityId, "IssueSeverity", creds),
      });
      origIssueArray.current[foundOrigIndex].issue_severity_id =
        issue.severityId;
    }

    if (
      origIssueArray.current[foundOrigIndex].project_task_id !=
      issue.projectTaskId
    ) {
      changeArray.push({
        field: "Task",
        oldVal: issue.originalTaskName,
        newVal: issue.newTaskName,
      });
      origIssueArray.current[foundOrigIndex].project_task_id =
        issue.projectTaskId;
    }

    if (
      (origIssueArray.current[foundOrigIndex].date_resolution_required
        ? origIssueArray.current[
            foundOrigIndex
          ].date_resolution_required.getTime()
        : 0) != (issue.dateReq ? issue.dateReq.getTime() : 0)
    ) {
      let oldValString = "";
      if (
        origIssueArray.current[foundOrigIndex].date_resolution_required !=
        "Invalid Date"
      ) {
        let oldVal = new Date(
          origIssueArray.current[foundOrigIndex].date_resolution_required,
        );
        oldVal.setTime(oldVal.getTime() - 1);
        oldValString = oldVal.toISOString().substring(0, 10);
      }
      let newVal = new Date(issue.dateReq);
      newVal.setTime(newVal.getTime() - 1);
      const newValString = newVal.toISOString().substring(0, 10);

      if (oldValString.trim() != "" && newValString.trim() != "1969-12-31") {
        changeArray.push({
          field: "Date Resolution Required",
          oldVal: oldValString,
          newVal: newValString,
        });
      }

      origIssueArray.current[foundOrigIndex].date_resolution_required =
        issue.dateReq;
    }
    if (
      (origIssueArray.current[foundOrigIndex].date_resolution_expected
        ? origIssueArray.current[
            foundOrigIndex
          ].date_resolution_expected.getTime()
        : 0) != (issue.dateExp ? issue.dateExp.getTime() : 0)
    ) {
      let oldValString = "";
      if (
        origIssueArray.current[foundOrigIndex].date_resolution_expected !=
        "Invalid Date"
      ) {
        let oldVal = new Date(
          origIssueArray.current[foundOrigIndex].date_resolution_expected,
        );
        oldVal.setTime(oldVal.getTime() - 1);
        oldValString = oldVal.toISOString().substring(0, 10);
      }
      let newVal = new Date(issue.dateExp);
      newVal.setTime(newVal.getTime() - 1);
      const newValString = newVal.toISOString().substring(0, 10);
      if (oldValString.trim() != "" && newValString.trim() != "1969-12-31") {
        changeArray.push({
          field: "Date Resolution Expected",
          oldVal: oldValString,
          newVal: newValString,
        });
      }

      origIssueArray.current[foundOrigIndex].date_resolution_expected =
        issue.dateExp;
    }

    if (
      (origIssueArray.current[foundOrigIndex].date_resolved
        ? origIssueArray.current[foundOrigIndex].date_resolved.getTime()
        : 0) != (issue.dateRes ? issue.dateRes.getTime() : 0)
    ) {
      let oldValString = "";
      if (
        origIssueArray.current[foundOrigIndex].date_resolved != "Invalid Date"
      ) {
        let oldVal = new Date(
          origIssueArray.current[foundOrigIndex].date_resolved,
        );
        oldVal.setTime(oldVal.getTime() - 1);
        oldValString = oldVal.toISOString().substring(0, 10);
      }
      let newVal = new Date(issue.dateRes);
      newVal.setTime(newVal.getTime() - 1);
      const newValString = newVal.toISOString().substring(0, 10);

      if (oldValString.trim() != "" && newValString.trim() != "1969-12-31") {
        changeArray.push({
          field: "Date Resolved",
          oldVal: oldValString,
          newVal: newValString,
        });
      }

      origIssueArray.current[foundOrigIndex].date_resolved = issue.dateRes;
    }

    let changeMessage =
      origIssueArray.current[foundOrigIndex].oada_issue_change_log__c || "";

    if (changeArray.length > 0) {
      changeArray.forEach((changeElem) => {
        changeMessage +=
          new Date().getTime() +
          "|" +
          userFirstName +
          " " +
          userLastName +
          ":c:" + // changed
          changeElem.field +
          ":f:" + // from
          changeElem.oldVal +
          ":t:" + // to
          changeElem.newVal +
          ":o:" + // on
          new Date().toDateString() +
          " at " +
          new Date().toLocaleTimeString("en-US", {
            timeZone: "America/New_York",
          }) +
          " ET||";
      });
    }

    const previousDetails =
      origIssueArray.current[foundOrigIndex].oada_req_details__c;

    origIssueArray.current[foundOrigIndex].description = issue.synopsis;
    origIssueArray.current[foundOrigIndex].issue_stage_id = issue.stageId;
    origIssueArray.current[foundOrigIndex].issue_category_id = issue.categoryId;
    origIssueArray.current[foundOrigIndex].issue_severity_id = issue.severityId;
    origIssueArray.current[foundOrigIndex].oada_req_details__c = editorDetails;
    origIssueArray.current[foundOrigIndex].oada_issue_change_log__c =
      changeMessage;

    const updateReqString =
      authString +
      '<Modify type="Issue" enable_custom="1"><Issue><id>' +
      issue.id +
      "</id><issue_stage_id>" +
      issue.stageId +
      "</issue_stage_id><issue_category_id>" +
      issue.categoryId +
      "</issue_category_id><issue_severity_id>" +
      issue.severityId +
      "</issue_severity_id><project_task_id>" +
      issue.projectTaskId +
      "</project_task_id><project_id>" +
      projectObject.id +
      "</project_id><user_id>" +
      issue.userId +
      "</user_id><description>" +
      issue.synopsis +
      "</description><date_resolution_required>" +
      Tools.parseDateObject(issue.dateReq ? issue.dateReq : null) +
      "</date_resolution_required><date_resolution_expected>" +
      Tools.parseDateObject(issue.dateExp ? issue.dateExp : null) +
      "</date_resolution_expected><date_resolved>" +
      Tools.parseDateObject(issue.dateRes ? issue.dateRes : null) +
      "</date_resolved><oada_req_details__c>" +
      Tools.encodeHTML(editorDetails) +
      "</oada_req_details__c><oada_req_previous_details__c>" +
      Tools.encodeHTML(previousDetails) +
      "</oada_req_previous_details__c><oada_issue_change_log__c>" +
      changeMessage +
      "</oada_issue_change_log__c></Issue></Modify></request>";

    Tools.fetchPost(updateReqString, urlString);

    if (removeRecordFromArray) {
      origIssueArray.current.splice(foundOrigIndex, 1);
    }
    setIssueArray(origIssueArray.current);
  };

  const addIssue = (issue, editorDetails) => {
    props.waitHandler(true);
    let changeMessage =
      new Date().getTime() +
      "|" +
      userFirstName +
      " " +
      userLastName +
      ":c:CREATED:f::t::o:" + // on
      new Date().toDateString() +
      " at " +
      new Date().toLocaleTimeString("en-US", {
        timeZone: "America/New_York",
      }) +
      " ET||";
    const addReqString =
      authString +
      '<Add type="Issue" enable_custom="1"><Issue><issue_category_id>' +
      ISSUE_CATEGORY_ID +
      "</issue_category_id><issue_severity_id>" +
      issue.severityId +
      "</issue_severity_id><issue_stage_id>" +
      issue.stageId +
      "</issue_stage_id><project_task_id>" +
      issue.projectTaskId +
      "</project_task_id><description>" +
      issue.synopsis +
      "</description><owner_id>" +
      creds.id +
      "</owner_id><project_id>" +
      projectObject.id +
      "</project_id><user_id>" +
      issue.userId +
      "</user_id><date>" +
      Tools.parseDateObject(new Date()) +
      "</date><date_resolution_required>" +
      Tools.parseDateObject(issue.dateReq ? issue.dateReq : null) +
      "</date_resolution_required><date_resolution_expected>" +
      Tools.parseDateObject(issue.dateExp ? issue.dateExp : null) +
      "</date_resolution_expected><date_resolved>" +
      Tools.parseDateObject(issue.dateRes ? issue.dateRes : null) +
      "</date_resolved><oada_req_details__c>" +
      Tools.encodeHTML(editorDetails) +
      "</oada_req_details__c><oada_issue_change_log__c>" +
      changeMessage +
      "</oada_issue_change_log__c></Issue></Add></request>";

    Tools.fetchPost(addReqString, urlString, "Issue").then((addResult) => {
      /*if (addResult.xml.length > 0) {
        const addResultArray = Tools.xmlToArray(addResult.xml);
        const dashboardItemList = sessionStorage.getItem(
          "dashboardItemList_" + props.raidType,
        );
        const dashboardItemListArray = dashboardItemList
          ? JSON.parse(dashboardItemList)
          : [];
        dashboardItemListArray.push(addResultArray[0]);
        sessionStorage.setItem(
          "dashboardItemList_" + props.raidType,
          JSON.stringify(dashboardItemListArray),
        );
      }*/
      sessionStorage.removeItem("dashboardItemList_" + props.raidType);
      isDirty(!dirty);
    });
  };

  const deleteIssue = (issueId) => {
    const delIndex = origIssueArray.current.findIndex(
      (elem) => elem.id == issueId,
    );
    console.log(delIndex);
    origIssueArray.current.splice(delIndex, 1);

    const deleteReqString =
      authString +
      '<Delete type="Issue"><Issue><id>' +
      issueId +
      "</id></Issue></Delete></request>";
    Tools.fetchPost(deleteReqString, urlString).then(() => {
      isDirty(!dirty);
    });
  };

  const redirectToSettings = () => {
    setOpenConfigAlert(false);
    props.openSettings();
  };

  //if (projectTeam.current.length > 0) {
  return (
    <>
      <RAIDComponent
        issueArray={issueArray}
        projectObject={projectObject}
        waitHandler={props.waitHandler}
        updateIssue={updateIssue}
        addIssue={addIssue}
        deleteIssue={deleteIssue}
        loadCompleted={loadCompleted.current}
        resetLoadCompleted={resetLoadCompleted}
        projectTeam={projectTeam.current}
        raidType={props.raidType}
      />
      <Dialog open={openConfigAlert} onClose={handleNotificationClose}>
        <Alert
          variant="filled"
          onClose={handleNotificationClose}
          severity="error"
          sx={{ fontSize: "large" }}
        >
          Configuration of Categories and Stages is not complete. An
          administrator must identify these in the SPP Instance Settings in
          order for this module to function properly..
          <DialogActions sx={{ paddingRight: "30px" }}>
            <Button
              className="settingsButtonActive"
              variant="filled"
              value="OK"
              onClick={redirectToSettings}
              sx={{ margin: "0px !important" }}
            >
              OK
            </Button>
          </DialogActions>
        </Alert>
      </Dialog>
    </>
  );
  //}
}

export default RAIDContainer;

RAIDContainer.propTypes = {
  waitHandler: PropTypes.func,
  openSettings: PropTypes.func,
  raidType: PropTypes.string,
};
